import hostname from "./config.host";
import { fetchWrapper } from "./fetch-wrapper";
const apiUrl: string = `${hostname}/aladdin_api/v1`;

function getInterface(oauthTokenHeader: string) {
  return fetchWrapper.get(
    `${apiUrl}/data_collection/affiliate_system_interfaces/`,
    oauthTokenHeader,
  );
}

function getDestinationTables(oauthTokenHeader: string) {
  return fetchWrapper.get(
    `${apiUrl}/data_collection/unifier_destination_tables/`,
    oauthTokenHeader,
  );
}

function getBusinessAdvisorMaps(
  oauthTokenHeader: string,
  interfaceID: string | number,
  destinationTableID?: string | number | null,
) {
  // the destination table is an optional filter - drop the segment when unset
  const destinationTableSegment = destinationTableID
    ? `${destinationTableID}/`
    : "";
  return fetchWrapper.get(
    `${apiUrl}/data_collection/advisor/business_advisor_maps/${interfaceID}/${destinationTableSegment}`,
    oauthTokenHeader,
  );
}

function getBusinessAdvisorMapsToBrands(
  oauthTokenHeader: string,
  mapID: string | number,
) {
  return fetchWrapper.get(
    `${apiUrl}/data_collection/advisor/business_advisor_maps_to_brands/${mapID}/`,
    oauthTokenHeader,
  );
}

function getGapRules(oauthTokenHeader: string) {
  return fetchWrapper.get(
    `${apiUrl}/data_collection/advisor/gap_rules/`,
    oauthTokenHeader,
  );
}

function createAdvisorMap(oauthTokenHeader: string, data: any) {
  return fetchWrapper.post(
    `${apiUrl}/data_collection/advisor/maps/`,
    data,
    oauthTokenHeader,
  );
}

function updateBusinessAdvisorMap(
  oauthTokenHeader: string,
  mapID: string | number,
  data: any,
) {
  return fetchWrapper.put(
    `${apiUrl}/data_collection/advisor/maps/${mapID}/`,
    data,
    oauthTokenHeader,
  );
}

function deleteAdvisorMap(oauthTokenHeader: string, mapID: string | number) {
  return fetchWrapper.delete(
    `${apiUrl}/data_collection/advisor/maps/${mapID}/`,
    undefined,
    oauthTokenHeader,
  );
}

function createGapRule(oauthTokenHeader: string, data: any) {
  return fetchWrapper.post(
    `${apiUrl}/data_collection/advisor/gap_rules/`,
    data,
    oauthTokenHeader,
  );
}

function updateGapRule(
  oauthTokenHeader: string,
  gapRuleID: string | number,
  data: any,
) {
  return fetchWrapper.put(
    `${apiUrl}/data_collection/advisor/gap_rules/${gapRuleID}/`,
    data,
    oauthTokenHeader,
  );
}

export const AdvisorMapsService = {
  getInterface,
  getDestinationTables,
  getBusinessAdvisorMaps,
  getBusinessAdvisorMapsToBrands,
  getGapRules,
  createGapRule,
  updateGapRule,
  createAdvisorMap,
  updateBusinessAdvisorMap,
  deleteAdvisorMap,
};
